export default {"src":"/_next/static/media/pet-dream-yard.52b41165.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};